// service/auth/useForgotPasswordMutation.ts
import { useMutation } from '@tanstack/react-query';
import { forgotPasswordApi } from './auth.api';


export const useForgotPasswordMutation = () => {
  return useMutation({
    mutationFn: (email: string) => forgotPasswordApi(email),
  });
};